import appStore from 'store';
import api from './api';
import { PAGINATION } from './constants';

const store = {
    namespaced: true,
    state: {
        tradePairList: [],
        pagination: PAGINATION,
        totalCount: 0,
        coinList: [],
        tradeArea: [],
        detailDialogVisible: false,
        pairConfigDetail: {},
        virtualTradeSet: [],
        plateList: []
    },
    getters: {
        tradePairList: state => state.tradePairList,
        coinList: state =>
            state.coinList.map(coin => {
                return {
                    label: coin,
                    value: coin
                };
            }),
        tradeArea: state =>
            state.tradeArea.map(area => {
                return {
                    label: area,
                    value: area
                };
            })
    },
    mutations: {
        setTradePairList(state, payload) {
            state.tradePairList = payload.list.slice();
            state.totalCount = payload.totalCount;
        },
        setPagination(state, payload) {
            state.pagination = payload;
        },
        setCoinList(state, payload) {
            state.coinList = payload;
        },
        setTradeArea(state, payload) {
            state.tradeArea = payload;
        },
        toggleDetailDialogVisible(state, payload) {
            state.detailDialogVisible = payload;
        },
        setPairConfigDetail(state, payload) {
            state.pairConfigDetail = payload;
        },
        setVirtualTradeSet(state, payload) {
            state.virtualTradeSet = payload;
        },
        setPlateList(state, payload) {
            state.plateList = payload;
        }
    },
    actions: {
        listAllCoin({ commit }) {
            api.getAllCoin().then(({ data }) => {
                commit('setCoinList', data);
            });
        },
        list({ commit }, { pair, area, page, size }) {
            api.getTradePairList({ pair, area, page, size }).then(({ data }) => {
                commit('setPagination', { page, size });
                commit('setTradePairList', data);
            });
        },
        // eslint-disable-next-line
        updateTradeStatus({ commit }, data) {
            return new Promise(resolve => {
                api.updateTradeStatus(data).then(res => {
                    resolve(res);
                });
            });
        },
        // eslint-disable-next-line
        updateTradePair({ commit }, data) {
            return new Promise(resolve => {
                api.updateTradePair(data).then(res => {
                    resolve(res);
                });
            });
        },
        // eslint-disable-next-line
        create({ commit }, tradePair) {
            return new Promise(resolve => {
                api.createTradePair(tradePair).then(res => {
                    resolve(res);
                });
            });
        },
        // eslint-disable-next-line
        remove({ commit }, pair) {
            return new Promise(resolve => {
                api.removeTradePair(pair).then(res => {
                    resolve(res);
                });
            });
        },
        // eslint-disable-next-line
        updateDefaultPrecision({ commit }, data) {
            return api.updateDefaultPrecision(data);
        },
        // eslint-disable-next-line
        transaction({ commit }, data) {
            return api.transaction(data);
        },
        getTradeArea({ commit }) {
            return api.getTradeArea().then(({ data }) => {
                commit('setTradeArea', data);
            });
        },
        updateSort(context, data) {
            return api.updateSort(data);
        },
        getPlateList({ commit }, data) {
            api.getPlateList(data).then(({ data }) => {
                commit('setPlateList', data);
            });
        }
        /*  queryVirtualTradeSet({commit}) {
          api.listVirtualTradeSet().then(response => {
            commit('setVirtualTradeSet',response.data);
          })
        }*/
    }
};

appStore.registerModule('tradePairSetting', store);